import { Stat } from "@modules/home/data/mockData";
import { trans } from "@mongez/localization";
import { ScrollNumber } from "./ScrollNumber";

type StatCardProps = {
  stat: Stat;
  isInView: boolean;
};

export function StatCard({ stat, isInView }: StatCardProps) {
  return (
    <div className="flex w-[180px] flex-col items-center bg-[#00081C] py-4 sm:w-[220px] sm:py-5 lg:w-[282px] lg:py-6">
      {/* Stats content */}
      <div className="z-10 w-[120px] sm:w-[150px] lg:w-[174px]">
        <div className="flex items-end gap-1 rtl:flex-row-reverse rtl:justify-end">
          <ScrollNumber number={stat.value} isInView={isInView} />
          {stat.suffix && (
            <span className="mb-4 text-lg text-bright-orange sm:text-2xl lg:text-[32px]">
              {stat.suffix}
            </span>
          )}
        </div>
        <h3 className="mt-2 text-sm font-semibold text-white sm:mt-3 sm:text-lg lg:mt-4 lg:text-xl">
          {trans(stat.title)}
        </h3>
        <p className="text-xs text-gray-400 sm:text-sm lg:text-base">
          {trans(stat.subtitle)}
        </p>
      </div>
    </div>
  );
}
